import { render, staticRenderFns } from "./SignTable.vue?vue&type=template&id=dbce011c&"
import script from "./SignTable.vue?vue&type=script&lang=js&"
export * from "./SignTable.vue?vue&type=script&lang=js&"
import style0 from "./SignTable.vue?vue&type=style&index=0&id=dbce011c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports